/**
 * Remembers the owners (Guild or User row IDs) someone recently created
 * Events for, most recent first, so the new Event form can preselect and
 * surface them. Per-browser convenience only: every read and write tolerates
 * storage being unavailable (SSR, native, private windows, blocked storage).
 */

const STORAGE_KEY = 'guild:recentEventOwners'
const MAX_RECENT = 3

const getStorage = (): Storage | null => {
  try {
    return typeof window !== 'undefined' && window.localStorage
      ? window.localStorage
      : null
  } catch {
    return null
  }
}

export const getRecentEventOwnerIds = (): string[] => {
  try {
    const raw = getStorage()?.getItem(STORAGE_KEY)
    if (!raw) return []
    const parsed: unknown = JSON.parse(raw)
    return Array.isArray(parsed)
      ? parsed
          .filter((id): id is string => typeof id === 'string')
          .slice(0, MAX_RECENT)
      : []
  } catch {
    return []
  }
}

export const rememberEventOwner = (ownerRowId: string) => {
  try {
    const next = [
      ownerRowId,
      ...getRecentEventOwnerIds().filter((id) => id !== ownerRowId),
    ].slice(0, MAX_RECENT)
    getStorage()?.setItem(STORAGE_KEY, JSON.stringify(next))
  } catch {
    // Storage full or blocked: remembering is best-effort.
  }
}
